import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useConfirmDialog } from 'shared/hooks/ui';
import { memo, useCallback, useState } from 'react';
import { useAction } from 'shared/hooks/redux/hooks';
import { deleteIconUser } from 'features/account.settings/ui/icon-settings/reducer/reducer';
import { Box, IconButton, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { ConverterIconsFromStringToSVG } from 'shared/components/icon/icon.user_icons_panel/converter_icon_from_string_to_svg';
export const DialogDeleteIconsUser = memo(function dialogDeleteIconsUser(props) {
    const { id } = props;
    const [ConfirmDialog, openConfirmDialog] = useConfirmDialog();
    const onDeleteIconUserAction = useAction(deleteIconUser);
    const [deleteId, setDeleteId] = useState(null);
    const handlerWindowRemove = useCallback(() => {
        setDeleteId(id);
        openConfirmDialog();
    }, []);
    const onExactDelete = useCallback(() => {
        if (deleteId) {
            onDeleteIconUserAction(deleteId);
        }
    }, [deleteId]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { display: 'flex', justifyContent: 'flex-end', children: _jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", children: _jsx(IconButton, { size: "small", onClick: () => handlerWindowRemove(), children: _jsx(ClearIcon, { sx: { fontSize: '1em' } }) }) }) }), _jsx(ConfirmDialog, { onConfirm: onExactDelete, children: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u043A\u043E\u043D\u043A\u0443?" })] }));
});
export const TitleIconsUser = memo(function dialogDeleteIconsUser(props) {
    const { icon, maintainColor } = props;
    return (_jsx(_Fragment, { children: icon && (_jsx(ConverterIconsFromStringToSVG, { iconToString: icon, maintainColor: maintainColor, fontSize: "10em" })) }));
});
